module.exports = __webpack_public_path__ + "static/media/precast-page.88cdc9a1.jpeg";